import { aboutInfo } from '@/pages/home/mocks/data';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
            品牌介绍
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">{aboutInfo.title}</h2>
        </div>

        <div className="space-y-4 mb-8">
          {aboutInfo.paragraphs.map((p, idx) => (
            <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">{p}</p>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {aboutInfo.features.map((f) => (
            <div key={f} className="flex items-center gap-2 px-4 py-3 rounded-lg bg-primary-50 border border-primary-100">
              <i className="ri-check-double-line text-primary-500 text-sm"></i>
              <span className="text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap">{f}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}